import { GeneralStatus } from 'modules/status-badge';

export interface Assignment {
  companyName: string;
  reportedMinutes: number;
  expectedMinutes: number;
  reportedReasonMinutes: number;
  weekStatus: GeneralStatus;
  weekAutoClosing: string;
  shifts: string[];
  reasons?: string[];
  isGeofenceEnabled: boolean;
  geofenceRadius?: number;
  location?: LocationJSON;
}

export interface LocationJSON {
  latitude: number;
  longitude: number;
}

export interface Shift {
  shiftStatus: GeneralStatus;
  shiftReportedMinutes: number;
  shiftStart: string;
}

export enum ReasonTimeMismatchType {
  COMPANY_DECISION = 'COMPANY_DECISION',
  TALENT_DECISION = 'TALENT_DECISION',
  COMPENSATION_MORE_HOURS = 'COMPENSATION_MORE_HOURS',
  COMPENSATION_LESS_HOURS = 'COMPENSATION_LESS_HOURS',
  TIME_OFF = 'TIME_OFF',
  COMMENT = 'COMMENT',
  TOO_MANY_PERIOD_HOURS = 'TOO_MANY_PERIOD_HOURS',
  TOO_MANY_SHIFTS = 'TOO_MANY_SHIFTS',
  SHIFT_END_TIME = 'SHIFT_END_TIME',
  SHIFT_START_TIME = 'SHIFT_START_TIME',
  BREAK_START_TIME = 'BREAK_START_TIME',
  BREAK_END_TIME = 'BREAK_END_TIME',
  TOO_LONG_SHIFT_DURATION = 'TOO_LONG_SHIFT_DURATION'
}

export interface Reason {
  message?: string;
  timeMismatchType: ReasonTimeMismatchType;
  reportedReasonMinutes: number;
  status?: GeneralStatus;
  effectiveReasonMinutes?: number;
  messageToTalent?: string;
}

export type Assignments = Record<string, Assignment>;

export type Shifts = Record<string, Shift>;

export type Reasons = Record<string, Reason>;

export interface WeekDetailsData {
  assignments: Assignments;
  shifts: Shifts;
  reasons?: Reasons;
}

export interface WeekDetails {
  data: WeekDetailsData;
}

// define other possible interfaces: 500, 400...
export type WeekDetailsResponse = WeekDetails;

export type WeekDetailsContextState = {
  weekDetails: WeekDetailsData | undefined;
  isLoading: boolean;
  isError: boolean;
};

// reducer types
export type ShiftState = {
  id: string | null;
  weekId: string | null;
  actions: { type: string }[];
};

export type ShiftAction =
  | { type: 'INIT_SHIFT'; payload: { id: string; weekId: string } }
  | { type: 'ABORT_SHIFT' }
  | { type: 'CONFIRM_SHIFT' };
